import request from "@/utils/request.js";
import { DownloadFile } from "@/utils/utils.js";
import { LANGUAGE_PACK } from "./config.js";
import _ from "lodash";
import {
  version,
  WeeklyTaskI18n,
  BadgeWallI18n,
  ChipHowToPlayI18n,
  GainEntryExplainI18n,
  GuideRoleI18n,
  SlotMachineI18n,
  YuliAttributesI18n,
  YuliHowToPlayI18n,
  AppHomeCenter,
  AppProfileCenter,
} from "@/locales";

/**
 * 获取所有所有语言包的资源路径
 * - 用于判断版本号
 * - 用于获取子模块的资源和版本号
 */
export const getAllLanguage = async (module) => {
  let res;
  try {
    res = await DownloadFile(LANGUAGE_PACK.get_all_language);
  } catch (error) {
    res = {};
  }
  const { h5_active_mission, h5_rule_center, home_center } = res;
  // 版本判断
  if (version == res?.version) {
    return true;
  } else {
    // 不符合返回最新对应模块数据
    if (module == "getWeeklyTask" && h5_active_mission) {
      // 周日任务
      return h5_active_mission;
    } else if (module == "getBadgeWall" && h5_active_mission) {
      // 徽章墙
      return h5_active_mission;
    } else if (module == "getChipHowToPlay" && h5_rule_center) {
      // 芯片玩法说明
      return h5_rule_center;
    } else if (module == "getGainEntryExplain" && h5_rule_center) {
      // yuli属性说明
      return h5_rule_center;
    } else if (module == "getSlotMachine" && h5_active_mission) {
      // 老虎机
      return h5_active_mission;
    } else if (module == "getGuideRole" && h5_rule_center) {
      // 角色技能说明
      return h5_rule_center;
    } else if (module == "getYuliAttributes" && h5_rule_center) {
      // 芯片词条属性说明
      return h5_rule_center;
    } else if (module == "getYuliHowToPlay" && h5_rule_center) {
      // 净化地脉玩法说明 
      return h5_rule_center;
    } else if (module == "getAppShopRank" && home_center) {
      // app 商店排行榜
      return home_center;
    } else {
      // 都不符合的情况下 - 沿用本地
      return true;
    }
  }
};

/**
 * 周日任务-语言包
 */
export const getWeeklyTaskLanguage = async () => {
  const versionConfig = await getAllLanguage("getWeeklyTask");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return WeeklyTaskI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};

/**
 * 徽章墙-语言包
 */
export const getBadgeWallLanguage = async () => {
  const versionConfig = await getAllLanguage("getBadgeWall");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return BadgeWallI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};

/**
 * 芯片玩法说明-语言包
 */
export const getChipHowToPlayLanguage = async () => {
  const versionConfig = await getAllLanguage("getChipHowToPlay");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return ChipHowToPlayI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};

/**
 * yuli属性说明-语言包
 */
export const getGainEntryExplainLanguage = async () => {
  const versionConfig = await getAllLanguage("getGainEntryExplain");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return GainEntryExplainI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};

/**
 * 老虎机-语言包
 */
export const getSlotMachineLanguage = async () => {
  const versionConfig = await getAllLanguage("getSlotMachine");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return SlotMachineI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};

/**
 * 角色技能说明-语言包
 */
export const getGuideRoleLanguage = async () => {
  const versionConfig = await getAllLanguage("getGuideRole");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return GuideRoleI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};

/**
 * 芯片词条属性说明-语言包
 */
export const getYuliAttributesLanguage = async () => {
  const versionConfig = await getAllLanguage("getYuliAttributes");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return YuliAttributesI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};

/**
 * 净化地脉玩法说明-语言包
 */
export const getYuliHowToPlayLanguage = async () => {
  const versionConfig = await getAllLanguage("getYuliHowToPlay");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return YuliHowToPlayI18n;
  } else {
    return DownloadFile(versionConfig?.resource_path);
  }
};

/**
 * app商店排行榜-语言包
 */
export const getAppShopRankLanguage = async () => {
  const versionConfig = await getAllLanguage("getAppShopRank");
  console.log("versionConfig: ", versionConfig);
  if (versionConfig == true) {
    return AppHomeCenter;
  } else {
    const res = await DownloadFile(versionConfig?.resource_path)
    return {
      ...res,
      ...BadgeWallI18n,
      ...AppProfileCenter,
    };
  }
};
